import { ehRodadaDeCopa } from './copa';
import { clubePorId, divisaoDoClube, type EstadoJogo, type PartidaJogada } from './jogo';
import type { ResultadoPartida } from './partida';

/**
 * Em que campeonato é um jogo da rodada: copa, Libertadores, Sul-Americana, uma liga estrangeira ou uma divisão brasileira.
 * Serve para o online mostrar (e o servidor enviar) só o que importa: os campeonatos em que algum técnico de verdade joga.
 */
export function competicaoDoJogo(e: EstadoJogo, rodada: number, x: { mandante: number; visitante: number }): string {
  if (ehRodadaDeCopa(e, rodada)) return 'copa';
  const nosDois = (ids: number[] | undefined): boolean => Boolean(ids?.includes(x.mandante) && ids.includes(x.visitante));
  if (e.libertadores?.slots.includes(rodada) && nosDois(e.libertadores.participantes)) return 'lib';
  if (e.sulamericana?.slots.includes(rodada) && nosDois(e.sulamericana.participantes)) return 'sul';
  const m = clubePorId(e, x.mandante);
  if (m.liga && e.mundo) return `liga:${m.liga}`;
  return e.acesso ? `div:${divisaoDoClube(e, m)}` : 'liga';
}

/** Campeonatos da rodada em que joga algum dos clubes dados (os dos técnicos de verdade). Vazio se nenhum deles joga. */
export function competicoesDosClubes(e: EstadoJogo, rodada: number, partidas: { mandante: number; visitante: number }[], clubes: (id: number) => boolean): Set<string> {
  const set = new Set<string>();
  for (const x of partidas) if (clubes(x.mandante) || clubes(x.visitante)) set.add(competicaoDoJogo(e, rodada, x));
  return set;
}

/**
 * Versão leve de um jogo que ninguém vai assistir: fica o placar, as estatísticas, a duração e os pênaltis (a linha do tempo da rodada
 * depende deles); saem os lances, as notas e as escalações, que são o que pesa.
 */
export function partidaEnxuta(p: PartidaJogada): PartidaJogada {
  const r: ResultadoPartida = p.resultado;
  return {
    ...p,
    resultado: {
      ...r,
      eventos: r.eventos.filter((ev) => ev.tipo === 'penalti' || ev.tipo === 'gol').map((ev) => ({ tempo: ev.tempo, minuto: ev.minuto, rotulo: ev.rotulo, tipo: ev.tipo, lado: ev.lado, jogador: ev.jogador, jogadorId: ev.jogadorId })),
      participacoes: [],
      escalacaoInicial: [
        { titulares: [], slots: [], reservas: [] },
        { titulares: [], slots: [], reservas: [] },
      ],
      emCampoFinal: [[], []],
    },
  };
}
